export default {
  Login: {
    LoginSuccess: 'Đăng nhập thành công',
    PleaseChooseSchool: 'Vui lòng chọn trường bạn đang công tác',
    SisapApp: 'Học tập và ôn luyện hiệu quả với ứng dụng SISAP HỌC SINH',
    NoteSisapApp: 'Quét mã QR Code để tải ứng dụng dành cho học sinh hoặc <a href={linkTo} target="_blank" style="color: #00a9ec">vào đây</a> để tải ứng dụng ngay'
  }
}
